import {ApiResponseError} from './v1/types';

export class ApiCustomError extends Error implements ApiResponseError {
  readonly extra_details: string;
  readonly error_code: string;
  readonly error_message: string;
  readonly [key: string]: any;
  constructor(details: ApiResponseError, ...params: any[]) {
    super(...params);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiCustomError);
    }

    this.name = 'ApiException';
    this.extra_details = details.extra_details;
    this.error_code = details.error_code;
    this.error_message = details.error_message;
    this.message = details.error_message;
    Object.assign(this, details);
  }
}
